module.exports = __webpack_public_path__ + "img/4.662eb40d.png";